import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { SvgColor, SvgMatType } from "src/app/constants/icons";
import { ServerConnectionModel } from "src/app/models/test-server";

import { AgentService } from "src/app/services/agent.service";
import { environment } from "src/environments/environment";

@Component({
    selector: 'mwp-manage-test-servers',
    templateUrl: './test-servers.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TestServersComponent implements OnInit {
    public serverConnectionModel: ServerConnectionModel = new ServerConnectionModel();
    public mwpAPIUrl = environment.api;
    public isLoaded: boolean;

    public svgType = SvgMatType;
    public svgColor = SvgColor;

    constructor(
        private agentService: AgentService,
    ) {
        
    }

    ngOnInit(): void {
    }

    public checkServerStatus(): void  {
        this.agentService.checkServerStatus().subscribe((response: ServerConnectionModel) =>{
            this.serverConnectionModel = response;
            this.isLoaded = true;
        });
    }
}